import type {
  DynamicPageRouterData,
  EditorSDK,
  Logger,
} from '@wix/wix-data-client-common-standalone'
import { partition } from 'lodash'
import { removeRedundantRoutesOrRouters } from './removeRedundantRoutesOrRouters'

const getPageResults = async ({
  editorSdkProxy,
  router,
}: {
  editorSdkProxy: EditorSDK
  router: DynamicPageRouterData
}) =>
  Promise.all(
    router.pages.map(async page => ({
      page,
      pageData: await editorSdkProxy.document.pages.getPageData({
        pageRef: page.pageRef,
      }),
    })),
  )

export const getPageToRouterMap = async ({
  editorSdkProxy,
  routers,
  logger,
}: {
  editorSdkProxy: EditorSDK
  routers: DynamicPageRouterData[]
  logger: Logger
}): Promise<Map<{ title: string; pageRef: string }, DynamicPageRouterData>> => {
  const map = new Map()

  for (const router of routers) {
    const pageResults = await getPageResults({ editorSdkProxy, router })

    const [validPages, invalidPages] = partition(pageResults, ({ pageData }) =>
      Boolean(pageData),
    )

    for (const { page, pageData } of validPages) {
      map.set({ title: pageData.title, pageRef: page.pageRef }, router)
    }

    await removeRedundantRoutesOrRouters({
      editorSdkProxy,
      router,
      validPagesCount: validPages.length,
      invalidPages,
      logger,
    })
  }

  return map
}
